import { gql } from '@apollo/client';

export const Products = {
  fragments: {
    main: gql`
      fragment MainProducts on Produit {
        name
        netWeight
        ttcPrice
        description
        catchPhrase
        venterebond
        ref
        isOut
        categorieproduits {
          data {
            id
            attributes {
              name
            }
          }
        }
        ingredients {
          id
          name
          percent
        }
        allergens {
          id
          name
        }
        shoppingMobile {
          id
          mobile
          description
        }
        characteristics {
          id
          characteristic
          value
        }
        media {
          data {
            id
            attributes {
              url
              name
            }
          }
        }
      }
    `
  }
};
